<template>
  <div>
    <a-form class="iotplt-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="型号">
            <a-input
              v-decorator="['name', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="按型号名称搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>

        <a-col :span="12" style="text-align: right">
          <a-form-item>
            <a-button type="primary" icon="shopping-cart" ghost @click="toCart">
              购物车 {{ cartItemsCount }}
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCartItemsCount } from '@/api/agent_purchase_item'

export default {
  name: 'SearchCpeGoods',
  data() {
    return {
      cartItemsCount: undefined,
      form: this.$form.createForm(this, { name: 'cpe_goods_search' })
    }
  },
  created() {
    findCartItemsCount().then((res) => {
      if (res.code === 0) {
        this.cartItemsCount = res.data.count
      }
    })
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },
    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    },
    toCart() {
      this.$router.push({ path: '/cart' })
    }
  }
}
</script>
